import { Autocomplete, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../redux/types'

interface ICountry {
  id: number
  name: string
}

function CountryAutocomplete({ value, handleInputChange }: any) {
  const { t } = useTranslation(['global'])

  const { countries } = useSelector((state: IRootState) => state.country)
  const { errorForm, msgForm } = useSelector((state: IRootState) => state.validator)

  const handleAutoCompleteChange = (country: ICountry | null) => {
    handleInputChange('country', country)
  }

  return (
    <Autocomplete
      id="autocomplete-countries"
      value={value}
      onChange={(_, value) => handleAutoCompleteChange(value)}
      options={countries}
      getOptionLabel={(option: ICountry) => (option.id !== undefined ? option.name : '')}
      renderInput={params => (
        <TextField
          {...params}
          error={errorForm.country}
          helperText={msgForm.country}
          label={t('country')}
          variant="filled"
          required
          InputLabelProps={{ shrink: true }}
        />
      )}
    />
  )
}

export default CountryAutocomplete
